import { FC } from 'react'
import { AppHead } from 'client/components/Layout/components/AppHead/AppHead'
import { DigitalDistributionContent } from 'client/contents/DigitalDistributionContent/DigitalDistributionContent'

type TProps = {}

const DigitalDistributionPage: FC<TProps> = () => {
  return (
    <article className="flex w-full flex-col bg-surface-white">
      <AppHead />
      <DigitalDistributionContent />
    </article>
  )
}

export default DigitalDistributionPage
